/* AtlassianIntelligenceToolbarButton.tsx generated by @compiled/babel-plugin v0.36.1 */
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./AtlassianIntelligenceToolbarButton.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useState } from 'react';
import { useIntl } from 'react-intl-next';
import { TOOLBAR_ACTION_SUBJECT_ID } from '@atlaskit/editor-common/analytics';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import { ToolbarSeparator } from '@atlaskit/editor-common/ui';
import { ToolbarButton } from '@atlaskit/editor-common/ui-menu';
import AtlassianIntelligenceIcon from '@atlaskit/icon/core/atlassian-intelligence';
import { fg } from '@atlaskit/platform-feature-flags';
import { LogoSvg as AtlassianIntelligenceLogo } from '@atlassian/generative-ai-modal/assets/Logo';
import sharedMessages from '@atlassian/generative-ai-modal/utils/messages';
import { useEditorToolbarChangeDetector } from '../../hooks/useEditorToolbarChangeDetector';
var iconMinWidthStyle = null;
var wrapperStyle = null;

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- This rule thinks this isn't a `css()` call due to the name mapping
var wrapperStylesUnbounded = null;

// This const is derived from the breakpoint where the toolbar hides its icons. It is used to hide the text in the AI button.
// Derived from values from platform/packages/editor/editor-core/src/ui/Appearance/FullPage/MainToolbar.tsx
var AI_BUTTON_WIDTH_BREAKPOINT = 1076;

// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/**
 * @deprecated This method is deprecated and should be cleaned up once all products using AI
 * are on composable editor.
 */
var deprecatedGetWidthState = function deprecatedGetWidthState(view) {
  var editorWidthPlugin = view.state.plugins.find(
  // Ignored via go/ees005
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function (plugin) {
    return plugin.key === 'widthPlugin$';
  });
  return {
    widthState: editorWidthPlugin === null || editorWidthPlugin === void 0 ? void 0 : editorWidthPlugin.getState(view.state)
  };
};
var shouldShowSeparator = function shouldShowSeparator(node) {
  var _node$previousElement, _node$previousElement2;
  if (!node) {
    return false;
  }

  // NOTE: Compiled CSS results in the previous sibling being a style tag rather then what was previously expected to be
  // another span/div tag. This is a temporary fix to ensure the separator is shown correctly.
  // As noted in the SSR compiled doco here (https://compiledcssinjs.com/docs/server-side-rendering) style elements are
  // inlined in the dom markup.
  var element = ((_node$previousElement = node.previousElementSibling) === null || _node$previousElement === void 0 ? void 0 : _node$previousElement.tagName) === 'STYLE' ? (_node$previousElement2 = node.previousElementSibling) === null || _node$previousElement2 === void 0 ? void 0 : _node$previousElement2.previousElementSibling : node.previousElementSibling;
  var prevSeparator = element === null || element === void 0 ? void 0 : element.querySelector(":scope > span:last-child:empty");
  var prevSeparatorVisible = prevSeparator && prevSeparator.clientWidth > 0;
  return !prevSeparatorVisible;
};
var WriteAIButton = function WriteAIButton(_ref) {
  var api = _ref.api,
    view = _ref.view,
    onClick = _ref.onClick,
    isDisabled = _ref.isDisabled;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var title = formatMessage(sharedMessages.aiUniversalDescriptor);
  var _useSharedPluginState = useSharedPluginState(api, ['width']),
    widthState = _useSharedPluginState.widthState;
  var shouldShowLabel = widthState !== null && widthState !== void 0 && widthState.width ? widthState.width >= AI_BUTTON_WIDTH_BREAKPOINT : true;
  if (!(widthState !== null && widthState !== void 0 && widthState.width) && view) {
    var _deprecatedGetWidthSt = deprecatedGetWidthState(view),
      deprecatedWidthState = _deprecatedGetWidthSt.widthState;
    shouldShowLabel = (deprecatedWidthState === null || deprecatedWidthState === void 0 ? void 0 : deprecatedWidthState.width) >= AI_BUTTON_WIDTH_BREAKPOINT;
  }
  return /*#__PURE__*/React.createElement(ToolbarButton, {
    onClick: onClick,
    buttonId: TOOLBAR_ACTION_SUBJECT_ID.AI,
    "aria-label": title,
    testId: "atlassian-intelligence-toolbar-button",
    title: title,
    iconBefore: /*#__PURE__*/React.createElement("span", {
      className: ax(["_1ul91tcg"])
    }, fg('platform-visual-refresh-icons') ? /*#__PURE__*/React.createElement(AtlassianIntelligenceIcon, {
      label: "atlassian-intelligence-toolbar-button-icon",
      spacing: "spacious"
    }) : /*#__PURE__*/React.createElement(AtlassianIntelligenceLogo, {
      alt: '',
      isDisabled: isDisabled
    })),
    disabled: isDisabled
  }, shouldShowLabel && formatMessage(sharedMessages.aiUniversalShortCallToAction));
};
export var AtlassianIntelligenceToolbarButton = function AtlassianIntelligenceToolbarButton(_ref2) {
  var onClick = _ref2.onClick,
    disabled = _ref2.disabled,
    ButtonWrapper = _ref2.ButtonWrapper,
    api = _ref2.api,
    view = _ref2.view;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showSeparator = _useState2[0],
    setShowSeperator = _useState2[1];
  var callbackRef = function callbackRef(node) {
    var result = shouldShowSeparator(node);
    setShowSeperator(result);
  };
  var aiButton = /*#__PURE__*/React.createElement(WriteAIButton, {
    api: api,
    view: view,
    onClick: onClick,
    isDisabled: disabled
  });
  var toolbarMutationCount = useEditorToolbarChangeDetector(ButtonWrapper);
  return /*#__PURE__*/React.createElement("span", {
    ref: callbackRef,
    className: ax(["_1e0c1txw _4cvr1h6o _18u0idpf _1ul91wug", "_p7r11txw _1xdi1txw _1ylx1txw _1fvdglyw _1c1bglyw"])
  }, showSeparator && /*#__PURE__*/React.createElement(ToolbarSeparator, null), ButtonWrapper ? /*#__PURE__*/React.createElement(ButtonWrapper, {
    key: "".concat(toolbarMutationCount, "-key-wrapper")
  }, aiButton) : aiButton);
};